<template>
  <div id="player-select">
    <img id="player-image" :src="getPlayerImg" />
    <div id="annual-salary">{{selectedCurrency}} {{annualSalary}} per year</div>
    <div id="player-tags">
      <div id="player-name">{{ selectedPlayer }}</div>
      <div id="player-team">{{ playerCat }}</div>
    </div>
    <player-dropdown></player-dropdown>
  </div>
</template>

<style lang="scss" scoped>

#player-select {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin:40px;
 
}
#player-image {
  width: 200px;
  background:$highlight1;
  border-radius:50%;
}
#player-tags {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 20px 0px 20px 0px;
}

#player-name {
  background: $blue;
  border-radius: 30px 0px 0px 30px;
  max-width: 240px;
  min-width:100px;
  color: $white;
  text-align: center;
  padding: 10px 30px 10px 30px; 
  @include respond(phone-only){
    font-size:14px;
    height:40px;
  }
}

#player-team {
  background: $white;
  color: $grey;
  border-radius: 0px 30px 30px 0px;
  max-width: 240px;
  min-width:100px;
  text-align: center;
  padding: 10px 30px 10px 30px; 
   @include respond(phone-only){
    font-size:14px;
     height:40px;
  }
}

#annual-salary{
  font-size:30px;
  margin:-10px 0px 0px 0px;
  color:$white;
  padding:0px 10px 0px 10px;
   @include respond(phone-only){
    font-size:20px;
  }
}
.highlight {
  color: $yellow;
}
</style>

<script>
import PlayerDropdown from "@/components/PlayerSalary/PlayerDropdown";
export default {
  components: {
    PlayerDropdown,
  },
  data() {
    return {
      playerData: [],
      chosenPic:"unknown.png",
    };
  },
  computed: {
    selectedPlayer() {
      return this.$store.getters.getPlayerData.player;
    },
    playerCat() {
      return this.$store.getters.getPlayerData.team;
    },
    getPlayerImg() {
      return require("../../assets/images/players/" + this.$store.getters.getPlayerData.image);
    },
    selectedCurrency() {
      return this.$store.getters.getCurrencySymbol;
    },
    annualSalary(){
      
      var earnings = this.$store.getters.getPlayerData.annualEarnings * this.$store.getters.getCurrencyRate;
      return this.humanFormat(Math.floor(earnings));
    }
  },
  methods: {
    humanFormat(profit) {
      return new Intl.NumberFormat().format(profit);
    },
  },
  mounted() {
    this.playerData = this.$store.getters.getPlayerData;
  },
};
</script>